import PropTypes from 'prop-types';
import React from 'react';
import Media from 'react-media';
import config from '../../config';
import OverlayThumb from '../OverlayThumb';

const renderImage = (poster, width, height) => (
  <OverlayThumb image={poster} width={width || '10rem'} height={height || '10rem'} />
);

const NextVideoImage = ({ poster }) => {
  if (!poster) return null;
  const { breakpoints } = config;
  const { large, medium, small } = breakpoints;
  return (
    <div className="next-video-image">
      <Media query={large} render={() => renderImage(poster)} />
      <Media query={medium} render={() => renderImage(poster, '7rem', '7rem')} />
      <Media query={small} render={() => renderImage(poster, '5rem', '5rem')} />
    </div>
  );
};

NextVideoImage.propTypes = {
  poster: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

NextVideoImage.defaultProps = {
  poster: null,
};

export default NextVideoImage;
